import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import API_BASE_URL from '../apiConfig'; // <--- NEW IMPORT
import '../App.css'; 

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
        // --- CHANGED URL HERE ---
        await axios.post(`${API_BASE_URL}/forgot-password`, { email });
        setSubmitted(true);
    } catch (err) {
        console.error(err);
        setSubmitted(true);
    } finally {
        setLoading(false);
    }
  };

  return (
    <div className="App">
      <Navbar />
      <header className="App-header" style={{minHeight: '80vh', justifyContent: 'center'}}>
        <div className="form-container" style={{textAlign: 'center', padding: '40px', maxWidth: '450px', width: '100%'}}>
            <h2>Reset Password</h2>
            
            {!submitted ? (
                <form onSubmit={handleSubmit}>
                    <p style={{color: '#666', marginBottom: '20px'}}>Enter your email address and we'll send you a link to reset your password.</p>
                    <div className="form-group" style={{textAlign: 'left'}}>
                        <label>Email</label>
                        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                    </div>
                    <button className="generate-button" type="submit" disabled={loading} style={{width: '100%', marginTop: '10px'}}>
                        {loading ? "Sending..." : "Send Reset Link"}
                    </button>
                    <div style={{marginTop: '20px'}}>
                        <Link to="/login" style={{color: '#0052cc', textDecoration: 'none'}}>Back to Login</Link>
                    </div>
                </form>
            ) : (
                <div>
                    <div style={{fontSize: '3rem', marginBottom: '15px'}}>📧</div>
                    <h3 style={{color: '#2e7d32'}}>Check your inbox</h3>
                    <p style={{color: '#555'}}>If an account exists for <strong>{email}</strong>, we have sent a password reset link.</p>
                    <Link to="/login" className="secondary-button" style={{display: 'inline-block', marginTop: '20px', textDecoration: 'none'}}>
                        Back to Login
                    </Link>
                </div>
            )}
        </div>
      </header>
      <Footer />
    </div>
  );
}

export default ForgotPasswordPage;